<template>
    <main class="main-content">
        <page-title :title="$t('beSmart.title')" style="background-position: right center" background="/assets/img/be-smart-bg.jpg?id=45124741"></page-title>

        <section class="section pb-0">
            <div class="content has-text-centered">
                <h3 v-t="'beSmart.section1.title'"></h3>
            </div>
            <div class="columns counters my-3">
                <div class="column is-4 has-text-centered">
                    <counter-item number="13" :text="$t('beSmart.section1.advantage1.text')"></counter-item>
                    <p v-t="'beSmart.section1.advantage1.content'"></p>
                </div>
                <div class="column is-4 has-text-centered">
                    <counter-item number="6" :text="$t('beSmart.section1.advantage2.text')"></counter-item>
                    <p v-t="'beSmart.section1.advantage2.content'"></p>
                </div>
                <div class="column is-4 has-text-centered">
                    <counter-item number="10" :text="$t('beSmart.section1.advantage3.text')"></counter-item>
                    <p v-t="'beSmart.section1.advantage3.content'"></p>
                </div>
            </div>
        </section>

        <section class="section pt-0">
            <div class="content has-text-centered">
                <h3 v-t="'beSmart.section3.title'"></h3>
                <p v-t="'beSmart.section3.text'"></p>
                <img src="/assets/img/green-energy.svg?id=45124741" class="energy-cert" alt="100% Green Energy - Dolomiti Energia">
            </div>
        </section>

        <parallax-section background="/assets/img/bask-of-grapes.jpg?id=45124741">
            <img class="be-smart-mark" src="/assets/img/environmental-friendly.png" alt="Environmental Friendly">
        </parallax-section>

        <section class="section">
            <div class="content has-text-centered">
                <h3 v-html="$t('beSmart.section2.title')"></h3>
            </div>
            <div class="mb-3">
                <div class="columns is-centered">
                    <div class="column is-half has-text-justified">
                        <p v-t="'beSmart.section2.paragraphs.1'"></p>
                        <p v-t="'beSmart.section2.paragraphs.2'"></p>
                        <p v-t="'beSmart.section2.paragraphs.3'"></p>
                        <p v-t="'beSmart.section2.paragraphs.4'"></p>
                    </div>
                </div>
            </div>

            <div class="columns is-multiline is-mobile">
                <div class="column is-4-tablet is-full-mobile mobile-order-2">
                    <img src="/assets/img/be-smart-advantages-1.jpg?id=45124741">
                </div>
                <div class="column is-4-tablet is-full-mobile mobile-order-3">
                    <img src="/assets/img/be-smart-advantages-2.jpg?id=45124741">
                </div>
                <div class="column is-4-tablet is-full-mobile mobile-order-1 is-flex has-items-center">
                    <ul class="fa-ul advantages-list">
                        <li><span class="fa-li"><i class="fas fa-check"></i></span> <span v-t="'beSmart.section2.advantages.1'"></span></li>
                        <li><span class="fa-li"><i class="fas fa-check"></i></span> <span v-t="'beSmart.section2.advantages.2'"></span></li>
                        <li><span class="fa-li"><i class="fas fa-check"></i></span> <span v-t="'beSmart.section2.advantages.3'"></span></li>
                        <li><span class="fa-li"><i class="fas fa-check"></i></span> <span v-t="'beSmart.section2.advantages.4'"></span></li>
                    </ul>
                </div>
            </div>
        </section>

    </main>
</template>
<script>
    import CounterItem from './../components/CounterItem'
    import PageTitle from './../components/PageTitle'
    import ParallaxSection from './../components/ParallaxSection'

    export default {
        components: {
            PageTitle,
            ParallaxSection,
            CounterItem
        },
        metaInfo() {
            return {
                title: this.$t('seo.beSmart.title'),
                meta: [
                    {name: 'title', content: this.$t('seo.beSmart.title')},
                    {name: 'description', content: this.$t('seo.beSmart.description')}
                ]
            }
        }
    }
</script>